export default __webpack_public_path__ + "static/media/icon-table-bug.917ac23f.svg";